export var USER_SESSION_INCLUDES = [
    // these includes are required for the hook and should never be removed
    'shops.photos',
    'shops.address',
    'shops.logo',
    'shops.barbers',
    'shops.barbers.photos',
    'shops.schedules',
    'barbers.shop.brand',
    'barbers.shop.brand.extensions',
    'barbers.shop.address',
    'brand',
    'brand.address',
    'brand.extensions',
    'firstShop',
    'permissions',
];
